const HorizontalLine = () => {
  return (
    <div className="border-b border-white my-16 mx-auto"></div>

  )
};
export default HorizontalLine
